import React, { PropTypes } from 'react';
import Form, { FormBody, SelectInput, DateInput, FormActions, TextInput } from '../../Form';
import moment from 'moment';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { observation as api } from '../../../actions/api';
import Spinner from '../../Spinner';
import { getDisplayDate, utc } from "../../../libs/date";
import AuditHistory from '../../AuditHistory';
import ReactModal from 'react-modal';
import { post } from '../../../actions/apiMethods';
import { preference } from '../../../libs/localStorage';

@inject('stationStore', 'parameterStore', 'qcFlagStore', 'userStore')
@observer
class EditObservation extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  slug = `/station/${this.props.params.id}/edit-observation`;
  columns = [
    { key: 'data_series', label: 'DataSeries ', editable: false },
    { key: 'time', label: 'Device Time', editable: false },
    { key: 'timestamp', label: 'Server Time', editable: false },
    { key: 'value', label: 'Value', editable: true },
    { key: 'unit', label: 'Unit', editable: false },
    { key: 'hqc', label: 'HQC', editable: true },
    { key: 'qc2', label: 'QC2', editable: false },
    { key: 'qc1', label: 'QC1', editable: false },
    { key: 'qc0', label: 'QC0', editable: false },
  ];

  @observable observationData = [];
  @observable loading = false;
  @observable items = [];
  @observable dataSeriesList = [];
  @observable filters = {
    data_series: '',
    date_from: moment().format('YYYY-MM-DDT00:00:00'),
    date_to: moment().add(1, 'day').format('YYYY-MM-DDT00:00:00'),
    edit_option: 1
  };
  @observable editInputValues = {
    scale: {
      m: '', c: ''
    },
    replace_with: '',
    change_flag: 0
  };
  @observable pagination = {
    limit: '25',
    index: 0,
    options: [{ num: '25' }, { num: '50' }, { num: '100' }, { num: '200' }]
  };
  @observable viewAudit = null;
  @observable addObservation = null;

  @action onViewAudit = id => this.viewAudit = id;
  @action onCloseAudit = () => this.viewAudit = null;

  editOptions = [{ id: 1, key: 'replace_with', name: 'Replace With' }, { id: 2, key: 'change_flag', name: 'Change HQC Flag' }, { id: 3, key: 'scale', name: 'Scale' }];

  dispose;
  componentWillMount() {
    const { params: { id }, stationStore, parameterStore, qcFlagStore, userStore, location: { query } } = this.props;
    if (!qcFlagStore.items.length && !qcFlagStore.isLoading) qcFlagStore.fetchItems();

    if (query.date_from && query.date_to && query.series_id) {
      this.filters = {
        data_series: query.series_id,
        date_from: query.date_from,
        date_to: query.date_to,
        edit_option: 1
      };
      this.onView();
    }
    if (stationStore.findById(id).data_series.length === 0) stationStore.fetchDataSeries(id);
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    if (!userStore.items.length && !userStore.isLoading) userStore.fetchItems();
    this.dispose = autorun(() => {
      stationStore.fetchDataOrigins(id);
      let dataSeriesList = [];
      stationStore.findById(id).data_series.length > 0 && stationStore.findById(id).data_series.map(item => {
        dataSeriesList.push({
          name: item.name,
          id: item.id,
          parameter: parameterStore.findById(item.parameter_id),
          table: item.table
        });
      });
      this.dataSeriesList = dataSeriesList;
    })
  }

  @action onChangeDataSeries = e => this.filters.data_series = e.target.value;
  @action onChangeDateFrom = e => this.filters.date_from = e.target.value;
  @action onChangeDateTo = e => this.filters.date_to = e.target.value;
  @action onChangeEditOption = e => this.filters.edit_option = e.target.value;
  @action onChangeFlag = e => this.editInputValues.change_flag = e.target.value;
  @action onChangeReplaceWith = e => this.editInputValues.replace_with = e.target.value;
  @action onChangeScaleM = e => this.editInputValues.scale.m = e.target.value;
  @action onChangeScaleC = e => this.editInputValues.scale.c = e.target.value;
  @action onChangePaginationLimit = e => {
    this.pagination.limit = e.target.value;
    this.pagination.index = 0;
  };

  @computed get getPaginatedTable() {
    if (this.observationData.length == 0) return [];
    if (!this.pagination.limit) return [this.observationData];

    let paginatedTable = [];
    for (let i = 0; i < this.observationData.length; i++) {
      let temp = [];
      for (let j = 0; j < this.pagination.limit; j++) {
        if (i < this.observationData.length) {
          temp.push(this.observationData[i]);
          if (j !== this.pagination.limit - 1) i++;
        } else {
          break;
        }
      }
      paginatedTable.push(temp);
    }
    return paginatedTable;
  }

  getEditOptionInput = (edit_option) => {
    const { qcFlagStore } = this.props;
    let editOptionInput = null;
    if (+edit_option === 2) {
      // editOptionInput =<select value={this.editInputValues.change_flag} onChange={this.onChangeFlag}>
      //   {this.props.qcFlagStore.items.map(item => (
      //     <option key={`qc-flag-${item.id}-${item.caption}`} value={item.caption}>{item.description}</option>
      //   ))}
      // </select>
      editOptionInput = <SelectInput id='change-flag' label='' value={this.editInputValues.change_flag} onChange={this.onChangeFlag} options={qcFlagStore.items} fields={{ label: 'description', value: 'caption' }} small />;
    } else if (+edit_option === 1) {
      editOptionInput = <div className='formInput'><input type="text" value={this.editInputValues.replace_with} onChange={this.onChangeReplaceWith} /></div>;
    } else if (+edit_option === 3) {
      let style = { minWidth: '40px', width: '40px', marginRight: '10px' };
      editOptionInput = <div className='formInput' style={{ display: 'inline-block' }}>
        <input style={style} type="text" placeholder="m" value={this.editInputValues.scale.m} onChange={this.onChangeScaleM} />
        <input style={style} type="text" placeholder="c" value={this.editInputValues.scale.c} onChange={this.onChangeScaleC} />
      </div>;
    }
    return editOptionInput;
  };

  onView = e => {
    e && e.preventDefault();
    const { qcFlagStore } = this.props;
    let filters = {
      station_id: this.props.params.id,
      date_from: this.filters.date_from,
      date_to: this.filters.date_to,
      series_id: this.filters.data_series
    };

    if (filters.series_id == '') delete filters.series_id;

    this.context.router.push({
      pathname: `/station/${this.props.params.id}/edit-observation`,
      query: filters
    })

    this.observationData = [];
    this.loading = true;

    let getProperFlag = flag => {
      let _flag = flag.toString().split('');
      let properFlag = [];
      for (let i = 0; i < 4 - _flag.length; i++) {
        properFlag.push(0);
      }
      _flag.map(x => {
        properFlag.push(+x);
      });
      return (properFlag)
    };

    api.fetchIndex(filters).then(res => {
      let data = [];
      res.map(item => {
        let qcFlag = getProperFlag(item.qc_flag);
        data.push({
          id: item.id,
          series_id: item.series_id,
          data_series: item.name,
          time: getDisplayDate(item.time),
          timestamp: getDisplayDate(item.timestamp),
          value: item.value,
          unit: item.unit == 'No Unit' ? item.unit : `${item.unit} (${item.symbol})`,
          hqc: qcFlag[0],
          qc2: qcFlag[1],
          qc1: qcFlag[2],
          qc0: qcFlag[3],
          selected: false,
          time_orig: item.time
        });
      });
      this.observationData = data;
      this.loading = false
    }).catch(err => {
      this.loading = false;
      this.context.notify.error({ message: err })
    });
  };

  onClickGo = e => {
    e.preventDefault();
    let selectedRows = this.getPaginatedTable[this.pagination.index].filter(item => item.selected == true);
    if (this.filters.edit_option == 3) {
      selectedRows.map(item => {
        item.value = +this.editInputValues.scale.m * +item.value + +this.editInputValues.scale.c;
        item.hqc = 2;
      });
    } else if (this.filters.edit_option == 1) {
      selectedRows.map(item => {
        item.value = this.editInputValues.replace_with;
        item.hqc = 2;
      });
    } else if (this.filters.edit_option == 2) {
      selectedRows.map(item => {
        item.hqc = this.editInputValues.change_flag;
      })
    }
  };

  onClickSave = e => {
    e.preventDefault();
    const { notify } = this.context;
    let selectedData = this.observationData.filter(item => item.selected == true);
    if (selectedData.length == 0) {
      notify.error({ message: 'no changes made' });
      return null;
    }
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm('Save?')) {
      this.loading = true;
      let payload = selectedData.reduce((acc, item) => {
        let series_table = this.dataSeriesList.find(ds => +ds.id === +item.series_id).parameter.table || 0;
        let observation_item = {
          id: item.id,
          value: !!item.value || item.value === 0 ? item.value : null,
          qc_flag: +`${item.hqc}${item.qc2}${item.qc1}${item.qc0}`,
          series_id: item.series_id,
          time: item.time_orig
        };
        if (!acc[series_table]) acc[series_table] = [observation_item];
        else acc[series_table].push(observation_item);
        return acc;
      }, {});
      api.updateMultiple(payload).then(res => {
        this.loading = false;
        notify.success({ message: 'Saved.' });
      }).catch(err => {
        this.loading = false;
        notify.error(err)
      });
    }
  };

  onSelectAll = (e, table) => table.map(item => item.selected = e.target.checked);

  onAddObservation = e => {
    e.preventDefault();
    const { stationStore } = this.props;
    const { notify } = this.context;

    const station = stationStore.findById(this.props.params.id);
    const dataSeries = station.data_series.find(item => item.id == this.filters.data_series);
    const dataOrigin = station.data_origin[0];
    if (!dataOrigin) {
      notify.error({ message: 'No data origin found.' });
      return null;
    }

    const originParameter = dataOrigin.data_origin_parameters.find(item => item.parameter_id == dataSeries.parameter_id);
    if (!dataOrigin) {
      notify.error({ message: 'No origin parameter found.' });
      return null;
    }

    const originTimezone = dataOrigin.timezone.split(':');
    let time = moment(this.addObservation.time)
      .subtract(moment.tz(preference.get().timezone || 'UTC')._offset, 'minutes')
      .add(+originTimezone[0], 'hours')
      .add(+originTimezone[1], 'minutes')
      .format('YYYY-MM-DDTHH:mm:ss');

    const payload = [{
      origin_code: dataOrigin.code,
      parameter_code: originParameter.code,
      time,
      value: this.addObservation.value,
    }];

    post('import', payload).then(res => {
      notify.success({ message: 'Observation Added.' });
      this.addObservation = null;
    }).catch(err => {
      console.log(err);
      notify.error({ message: err.toString() });
    });

  }

  render() {
    let paginatedTable = this.getPaginatedTable;

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Data Series'}
              fields={{ label: 'name', value: 'id' }}
              value={this.filters.data_series}
              options={this.dataSeriesList}
              onChange={this.onChangeDataSeries}
              filterOptions={(options, filterText) => this.props.parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <DateInput
              label="Date From"
              type="datetime-local"
              value={moment(this.filters.date_from).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              type="datetime-local"
              label="Date To"
              value={moment(this.filters.date_to).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={this.onChangeDateTo}
            />
            <button onClick={this.onView}>View</button>
            <div className='bordered indented-form fit-content'>
              <span>Edit Option</span>
              <div className="inline-grid">
                <SelectInput id='edit-options' label='' value={this.filters.edit_option} options={this.editOptions} onChange={this.onChangeEditOption} fields={{ label: 'name', value: 'id' }} small />
                {/* <select onChange={this.onChangeEditOption} value={this.filters.edit_option}>{this.editOptions.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)}</select> */}
                {this.getEditOptionInput(this.filters.edit_option)}
                <button style={{ margin: 0 }} onClick={this.onClickGo}>GO</button>
                <button style={{ margin: 0 }} onClick={this.onClickSave}>Save</button>
              </div>
            </div>
          </FormBody>
        </Form><br />
        {paginatedTable.length > 0 && this._renderTablePagination(paginatedTable)}
        <div className="DataTable overflow-x-scroll">
          <table>
            <thead><tr>
              <th><input type="checkbox" onChange={e => this.onSelectAll(e, paginatedTable[this.pagination.index])} /></th>
              {this.columns.map((item, index) => <th key={index}>{item.label}</th>)}
              <th />
              <th />
            </tr></thead>
            <tbody>{paginatedTable.length > 0 && paginatedTable[this.pagination.index].map((tr, tri) =>
              <tr key={tri}>
                <td><input type="checkbox" checked={tr.selected} onChange={() => tr.selected = !tr.selected} /></td>
                {this.columns.map((col, tdi) => <td key={tdi}>{`${tr[col.key]}`}</td>)}
                <td><a onClick={() => this.onViewAudit(`${tr.series_id}_${tr.time_orig.split('.')[0]}${!!tr.id ? '_' + tr.id : ''}`)}>View Audit</a></td>
                <td><a onClick={() => {
                  this.addObservation = {
                    index: (this.pagination.limit * this.pagination.index) + tri,
                    // time: !prevItem ? '' : moment(prevItem.time).add((new Date(tr.time).valueOf() - new Date(prevItem.time).valueOf()) / 2000, 'seconds').format('YYYY-MM-DDTHH:mm:ss'),
                    time: tr && tr.time,
                    // value: !prevItem ? '' : (tr.value + prevItem.value) / 2,
                    value: tr && tr.value
                  }
                }}><i className='fa fa-plus' /></a></td>
              </tr>
            )}</tbody>
          </table>
        </div>
        {this.viewAudit && <AuditHistory title={`Observation Audit History`} onRequestClose={this.onCloseAudit} audit_table={'observation'} link={this.viewAudit} />}
        {this.addObservation && this._renderAddObservation()}
        {this.loading && <Spinner />}
      </div>
    );
  }

  _renderAddObservation = () => {
    const onRequestClose = () => this.addObservation = null;
    const title = 'Add Observation';
    // const prev = this.getPaginatedTable[this.pagination.index][this.addObservation.index + 1];
    // const next = this.getPaginatedTable[this.pagination.index][this.addObservation.index];
    const prev = this.observationData[this.addObservation.index + 1];
    const next = this.observationData[this.addObservation.index - 1];

    return <ReactModal
      isOpen
      onRequestClose={onRequestClose}
      className="Modal"
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
        },
        content: {
          backgroundColor: 'white',
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      }}
      contentLabel={title}
    >
      <div className="modalHeader">
        <div className="modalHeaderTitle">{title}</div>
        <a className="modalHeaderClose" onClick={onRequestClose}>
          <i className="fa fa-close" aria-hidden="true"></i>
        </a>
      </div>
      <div className='modalChildren'>
        <div className='DataTable'>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Time</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Previous</th>
                <td>{!!prev ? prev.time : ''}</td>
                <td>{!!prev ? prev.value : ''}</td>
              </tr>
              <tr>
                <th>Next</th>
                <td>{!!next ? next.time : ''}</td>
                <td>{!!next ? next.value : ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <Form>
          <FormBody>
            <DateInput
              type="datetime-local"
              label="Time"
              value={moment(this.addObservation.time).format('YYYY-MM-DDTHH:mm:ss')}
              onChange={e => this.addObservation.time = e.target.value}
            />
            <TextInput label='Value' value={this.addObservation.value} onChange={e => this.addObservation.value = e.target.value} />
          </FormBody>
          <FormActions>
            <button onClick={this.onAddObservation}>Save</button>
          </FormActions>
        </Form>
      </div>
    </ReactModal>;
  }

  _renderTablePagination = (paginatedTable) => {
    return (
      <div className='inline-grid v-center' style={{ gap: 0 }}>
        <div className='inline-grid v-center'>
          <label>Pagination</label>
          <SelectInput id='pagination' label="" fields={{ label: 'num', value: 'num' }} value={this.pagination.limit} options={this.pagination.options} onChange={this.onChangePaginationLimit} small />
        </div>
        <span className='flex-grow' />
        <div className='v-center'>
          <span className='button button-inactive' onClick={() => this.pagination.index = 0} ><i className="fa fa-angle-double-left" /></span>
          <span className='button button-inactive' onClick={() => this.pagination.index != 0 && this.pagination.index--} ><i className="fa fa-angle-left" /></span>
          <b style={{ margin: '0 8px' }}>{this.pagination.index + 1} of {paginatedTable.length}</b>
          <span className='button button-inactive' onClick={() => this.pagination.index != paginatedTable.length - 1 && this.pagination.index++} ><i className="fa fa-angle-right" /></span>
          <span className='button button-inactive' onClick={() => this.pagination.index = paginatedTable.length - 1} ><i className="fa fa-angle-double-right" /></span>
        </div>
      </div>
    )
  }

}

export default EditObservation;


// WEBPACK FOOTER //
// ./src/components/Station/EditObservation/EditObservation.js